import BaseApi from '../base/base'
import Enrollment from '../../models/enrollment'

export default class EnrollmentApi extends BaseApi {
  constructor() {
    super()
    this.path = '/enrollments'
  }

  async index(params = {}, page = 0) {
    this.path = '/enrollments'
    const response = await this.getRequest({
      ...params,
      page
    })
    return response.data.map((element) => {
      return new Enrollment(element)
    })
  }

  async show(params = {}) {
    this.path = '/enrollments/0'
    const response = await this.getRequest(params)
    return response.data
  }

  async create(params = {}) {
    this.path = '/enrollments/'
    const response = await this.postRequest(params)
    return response.data
  }
}
